import { INDIA, STATES } from "../data/india";

export default function StateCitySelect({ state, city, onChange, allowAll = false, prefix = "" }) {
  const cities = state && INDIA[state] ? [...INDIA[state]].sort() : [];
  return (
    <>
      <div>
        <label className="lux-label">State / UT</label>
        <select className="lux-select" value={state} data-testid={`${prefix}state-select`} onChange={(e) => onChange({ state: e.target.value, city: "" })}>
          <option value="">{allowAll ? "All India" : "Select state"}</option>
          {STATES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div>
        <label className="lux-label">City</label>
        <select className="lux-select" value={city} disabled={!state} data-testid={`${prefix}city-select`} onChange={(e) => onChange({ state, city: e.target.value })}>
          <option value="">{allowAll ? "All cities" : "Select city"}</option>
          {cities.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
    </>
  );
}
